import { useEffect } from "react";
import { useAuthContext } from './hooks/useAuthContext';

const HTTP = async (url, method, data={}) => {
	const user = JSON.parse(localStorage.getItem('user'));

	if (!user) {
		window.location.replace('/login')
	}

	let config = {
		method: method,
		headers: {
			'Content-Type': 'application/json',
			"Authorization": user.token
		},
	}

	if (Object.keys(data).length > 0) {
		config.body = JSON.stringify(data);
	}

	let response;

	try{
		response = await fetch(url, config);
	}catch(e){
		console.error(e);

		return {
			success: false,
		};
	}

	if (response.status === 401) {
	    localStorage.removeItem('user');
		window.location.replace('/login')

		return;
	}

	return response;
}

const httpGet = async (url, data) => {
	return await HTTP(url, 'GET', data);
}

const httpPost = async (url, data) => {

	return await HTTP(url, 'POST', data);
}

const httpPut = async (url, data) => {
	return await HTTP(url, 'PUT', data);
}

const httpDelete = async (url, data) => {
	return await HTTP(url, 'DELETE', data);
}

const httpPatch = async (url, data) => {
	return await HTTP(url, 'PATCH', data);
}

export { httpGet, httpPost, httpPut, httpDelete, httpPatch };